export default __webpack_public_path__ + "static/dots-f18e5f24a15b33f43056726b75bc58ab.svg";